// import React, { useEffect } from 'react';

// function LinkTowPoint() {
//   useEffect(() => {

//     function initMap() {
//       var myLatLng = { lat: 33.515909696038776, lng: 36.293423317790975 };

//       var map = new window.google.maps.Map(document.getElementById('map'), {
//         zoom: 12,
//         center: myLatLng,
//       });

//       var directions = [
//         {
//           distance: '78 م',
//           duration: '1 دقيقة',
//           html_instructions: 'الاتجاه نحو اليسار ',
//           start_location_lat: 33.5016518,
//           start_location_long: 36.4655601,
//           end_location_lat: 33.5018527,
//           end_location_long: 36.4648661,
//           poly_line: 'ihnkEwdq}EBp@E`AWHMJ',
//         },
//         {
//           distance: '0.4 كم',
//           duration: '1 دقيقة',
//           html_instructions: 'الاتجاه نحو اليسار ',
//           start_location_lat: 33.5018527,
//           start_location_long: 36.4648661,
//           end_location_lat: 33.5039901,
//           end_location_long: 36.4633218,
//           poly_line: 'qinkEm`q}E`@nD?|Ae@PgDFu@Bk@Rg@?U?[AcAG',
//         },
//       ];

//       directions.forEach(function (direction) {
//         var startLat = direction.start_location_lat;
//         var startLng = direction.start_location_long;
//         var endLat = direction.end_location_lat;
//         var endLng = direction.end_location_long;

//         var startLatLng = new window.google.maps.LatLng(startLat, startLng);
//         var endLatLng = new window.google.maps.LatLng(endLat, endLng);

//         var lineCoordinates = [startLatLng, endLatLng];

//         var line = new window.google.maps.Polyline({
//           path: lineCoordinates,
//           geodesic: true,
//           strokeColor: '#FF0000',
//           strokeOpacity: 1.0,
//           strokeWeight: 3,
//         });

//         line.setMap(map);

//         var startMarker = new window.google.maps.Marker({
//           position: startLatLng,
//           map: map,
//           title: 'نقطة البداية',
//         });

//         var endMarker = new window.google.maps.Marker({
//           position: endLatLng,
//           map: map,
//           title: 'نقطة النهاية',
//         });

//         startMarker.setMap(map);
//         endMarker.setMap(map);
//       });
//     }

//     if (typeof window.google !== 'undefined') {
//       initMap();
//     }
//   }, []);

//   return <div id="map" style={{ height: '400px' }}></div>;
// }

// export default LinkTowPoint;

import React, { useEffect } from 'react';
import polyline from '@mapbox/polyline';

function LinkTowPoint() {
  useEffect(() => {
    function initMap() {
      var myLatLng = { lat: 33.515909696038776, lng: 36.293423317790975 };

      var map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: myLatLng,
      });

      var directions = [
        {
          distance: '0.1 كم',
          duration: '1 دقيقة',
          html_instructions: 'الاتجاه مباشرة إلى الشمال ',
          start_location_lat: 33.5006435,
          start_location_long: 36.4659932,
          end_location_lat: 33.5016518,
          end_location_long: 36.4655601,
          poly_line: '_bnkEmgq}EOBw@D_@RHHDTq@Pk@DS?',
        },
        {
          distance: '78 م',
          duration: '1 دقيقة',
          html_instructions: 'الاتجاه نحو اليسار ',
          start_location_lat: 33.5016518,
          start_location_long: 36.4655601,
          end_location_lat: 33.5018527,
          end_location_long: 36.4648661,
          poly_line: 'ihnkEwdq}EBp@E`AWHMJ',
        },
        {
          distance: '0.4 كم',
          duration: '1 دقيقة',
          html_instructions: 'الاتجاه نحو اليسار ',
          start_location_lat: 33.5018527,
          start_location_long: 36.4648661,
          end_location_lat: 33.5039901,
          end_location_long: 36.4633218,
          poly_line: 'qinkEm`q}E`@nD?|Ae@PgDFu@Bk@Rg@?U?[AcAG',
        },
        {
          distance: '9.5 كم',
          duration: '12 دقيقة',
          html_instructions: 'الاتجاه نحو اليسار ',
          start_location_lat: 33.5039901,
          start_location_long: 36.4633218,
          end_location_lat: 33.4948582,
          end_location_long: 36.3628158,
          poly_line:
            '}vnkEwvp}E?B@XD^LjATvARrAF^Lv@Hj@ZjBL|@BPT|APhAv@nEh@|CDX@DNx@PjADT@BRpAZrBTtA@FDRRbAP`ARnAHn@@^Jp@BZ@?V?r@E`AEpAEjAA`@ABGpACp@AL?LAXCx@CvA?LCbAC`AC~@Cl@Cb@Cx@C`@Cb@EnAGjACz@GdBCt@APCh@EpAEnAAL?P?N?\\@ZB`@B|@?@Bl@F~@?L@N?BDf@FjABp@Bj@FfADx@?FBd@@p@Bd@?FBp@F`A@LFt@?D@VDt@Bj@B\\FpA@RBh@Dn@Bh@@d@Fr@@PDt@Bd@@P@n@@DAd@FxAJjB?NFjALhC@N?JHdAVhEDj@N`C?DPpBNdBXjDP~B?tA@hB?j@?n@AfA?d@?R?|E?xB?D@hB@vA@jD@jB?^?l@@x@?fED|@@t@@\\@ZPp@Ld@Nb@NZHRPd@BLJl@P`AThAf@tCBLRhABNLn@|@hFxAlHXjBF\\F`@Db@d@hF?Dr@nIPnBJnAN`BJfAT`CFh@~@vKBTn@bJDf@\\~CBZDTV`BLh@Nn@Np@FVl@vBbAtDXlAb@rB?@FdAFbADt@Ad@]jECXQxCEjAGbBMnDALE?V?BAvA?f@A\\ATE`@c@fGE`@CXMx@CPy@jFKn@UpBCd@Af@@L?ZFp@FZJZRh@Nr@@BLf@LrALrAFdAJ`BD|@?LBnE@v@?\\@~@@tAHbD@v@Ax@A`A?n@?@A`AAv@ApDCzC?JC|E?FExBQ|HARAz@@n@@t@?dA?FA|A?@?j@CrC?@T~G@J@R@VJrCD`AJzBF|@RfCDf@TzBBP@RRv@L\\L\\HRl@`BDJHTFRJl@cAhD',
        },
        {
          distance: '2.7 كم',
          duration: '5 دقيقة',
          html_instructions: 'المتابعة في خط مستقيم',
          start_location_lat: 33.4948582,
          start_location_long: 36.3628158,
          end_location_lat: 33.5035373,
          end_location_long: 36.3360492,
          poly_line:
            '{}lkEsb}|ESFiBhEeBlFm@zBSv@s@fDQx@_AhEw@rDYrA]hBc@xCKp@IrAIrAGtAGzAEj@]lHWxB]xC_@|BIr@?@s@nFY|Be@hDm@`EOl@{@nCgA|Cc@vAsBlGUj@uA|DSj@O\\KZITy@vBm@zAaBlEIPs@nBSp@K\\Oh@g@nB',
        },
      ];

      directions.forEach(function (direction) {
        var decodedCoordinates = polyline.decode(direction.poly_line);
        var lineCoordinates = decodedCoordinates.map(function (coordinate) {
          return { lat: coordinate[0], lng: coordinate[1] };
        });

        var line = new window.google.maps.Polyline({
          path: lineCoordinates,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });

        line.setMap(map);

        var startLatLng = lineCoordinates[0];
        var endLatLng = lineCoordinates[lineCoordinates.length - 1];

        var startMarker = new window.google.maps.Marker({
          position: startLatLng,
          map: map,
          title: 'نقطة البداية',
        });

        var endMarker = new window.google.maps.Marker({
          position: endLatLng,
          map: map,
          title: 'نقطة النهاية',
        });

        startMarker.setMap(map);
        endMarker.setMap(map);
      });
    }

    if (typeof window.google !== 'undefined') {
      initMap();
    }
  }, []);

  return <div id="map" style={{ height: '400px' }}></div>;
}

export default LinkTowPoint;
